"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockToJSON = exports.BlockFromJSONTyped = exports.BlockFromJSON = void 0;
function BlockFromJSON(json) {
    return BlockFromJSONTyped(json, false);
}
exports.BlockFromJSON = BlockFromJSON;
function BlockFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canonical': json['canonical'],
        'height': json['height'],
        'hash': json['hash'],
        'parent_block_hash': json['parent_block_hash'],
        'burn_block_time': json['burn_block_time'],
        'burn_block_time_iso': json['burn_block_time_iso'],
        'burn_block_hash': json['burn_block_hash'],
        'burn_block_height': json['burn_block_height'],
        'miner_txid': json['miner_txid'],
        'parent_microblock_hash': json['parent_microblock_hash'],
        'parent_microblock_sequence': json['parent_microblock_sequence'],
        'txs': json['txs'],
        'microblocks_accepted': json['microblocks_accepted'],
        'microblocks_streamed': json['microblocks_streamed'],
        'execution_cost_read_count': json['execution_cost_read_count'],
        'execution_cost_read_length': json['execution_cost_read_length'],
        'execution_cost_runtime': json['execution_cost_runtime'],
        'execution_cost_write_count': json['execution_cost_write_count'],
        'execution_cost_write_length': json['execution_cost_write_length'],
    };
}
exports.BlockFromJSONTyped = BlockFromJSONTyped;
function BlockToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'canonical': value.canonical,
        'height': value.height,
        'hash': value.hash,
        'parent_block_hash': value.parent_block_hash,
        'burn_block_time': value.burn_block_time,
        'burn_block_time_iso': value.burn_block_time_iso,
        'burn_block_hash': value.burn_block_hash,
        'burn_block_height': value.burn_block_height,
        'miner_txid': value.miner_txid,
        'parent_microblock_hash': value.parent_microblock_hash,
        'parent_microblock_sequence': value.parent_microblock_sequence,
        'txs': value.txs,
        'microblocks_accepted': value.microblocks_accepted,
        'microblocks_streamed': value.microblocks_streamed,
        'execution_cost_read_count': value.execution_cost_read_count,
        'execution_cost_read_length': value.execution_cost_read_length,
        'execution_cost_runtime': value.execution_cost_runtime,
        'execution_cost_write_count': value.execution_cost_write_count,
        'execution_cost_write_length': value.execution_cost_write_length,
    };
}
exports.BlockToJSON = BlockToJSON;
//# sourceMappingURL=Block.js.map